
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { LxResponsiveClassDirective } from '../../../directives/lx-responsive-class.directive';

import { Offer } from '../../../model/offer';
import { UiNewOfferTab } from '../ui-new-offer-nav-bar/ui-new-offer-nav-bar.component';

@Component({
  selector: 'ui-new-view-bar',
  standalone: true,
  imports: [LxResponsiveClassDirective],
  templateUrl: './ui-new-view-bar.component.html',
  styleUrl: './ui-new-view-bar.component.scss',
})
export class UiNewViewBarComponent {
  @Input() hasOffers = false;
  @Input() selectedTab: UiNewOfferTab = 'ROOM';

  /** The unfiltered/full set of offers for the current tab - used for UI decisions that depend on total count */
  @Input() offerCount: number | null = null;

  @Input() viewMoreToggle = false;
  @Input() viewMoreOrLessText = 'View More';

  // Used for deciding the label text in the parent (kept for parity with home)
  @Input() offers: Offer[] | null = null;

  @Output() noThanksClicked = new EventEmitter<void>();
  @Output() viewMoreClicked = new EventEmitter<void>();
}
